import { createClient } from '@supabase/supabase-js';

// AICIS Supabase configuration
const aicisSupabaseUrl = process.env.REACT_APP_AICIS_SUPABASE_URL;
const aicisSupabaseKey = process.env.REACT_APP_AICIS_SUPABASE_ANON_KEY;

// ABVIG Supabase configuration
const abvigSupabaseUrl = process.env.REACT_APP_ABVIG_SUPABASE_URL;
const abvigSupabaseKey = process.env.REACT_APP_ABVIG_SUPABASE_ANON_KEY;

// Create clients
export const aicisSupabase = createClient(aicisSupabaseUrl, aicisSupabaseKey);
export const abvigSupabase = createClient(abvigSupabaseUrl, abvigSupabaseKey);

// Export both clients
const supabaseClients = { aicisSupabase, abvigSupabase };
export default supabaseClients;